"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.scss");
function Toast(_a) {
    var message = _a.message;
    return (React.createElement("div", { className: styles.toastContainer },
        React.createElement("div", { className: styles.toastContent },
            React.createElement("span", null, message))));
}
exports.default = Toast;
